<template>
  <div
    class="w-full"
    style="min-width: 320px;white-space: nowrap"
  >
    <div class="mb-1.5 font-bold text-sm">Categories</div>
    <div class="overflow-y-auto pb-3">
      <div class="inline-flex rounded-md space-x-3" role="group">
        <button
          @click="SetCategoryFilter(category.value)"
          class="px-4 py-2 text-sm border-2 rounded-md hover:bg-primary-600 hover:border-primary-600 hover:text-secondary-600 focus:z-10 focus:ring-none focus:bg-primary-600 focus:border-primary-600 focus:text-secondary-600"
          :class="filter === category.value ? 'bg-primary-600 border-primary-600 text-secondary-600' : 'bg-transparent border-gray-800 text-gray-800'"
          :key="category.id"
          type="button"
          v-for="category in categories"
          style="display: inline-block"
        >
          {{ category.label }}
        </button>
      </div>
    </div>
  </div>

</template>

<script setup>
import { useProductsStore } from '@/stores/products';
import { useProductCategoriesStore } from '@/stores/productCategories';

import { ALL_FILTERS } from '@/constants';

import { computed, onBeforeUnmount } from 'vue';

const {
  SetCategoryFilter,
} = useProductsStore();

const Filter = computed(() => useProductsStore().CategoryFilter);
const ProductCategories = computed(() => useProductCategoriesStore().Data);

const filter = computed({
  get() {
    return Filter.value;
  },
  set(v) {
    SetCategoryFilter(v);
  },
});
const categories = computed(() => {
  const options = [ALL_FILTERS];
  const data = (ProductCategories.value ?? [])
    .map((c) => ({
      label: c.name,
      value: c.id,
    }))
    .sort((a, b) => (a.label < b.label ? -1 : 1));
  options.push(...data);
  return options;
});

onBeforeUnmount(() => {
  SetCategoryFilter(ALL_FILTERS.value);
});
</script>
